import AlertMenu from './AlertMenu';

export default AlertMenu;
